/**
 * 相邻 view 的联动交互
 */
import './association';
//# sourceMappingURL=index.js.map